import {
  BasicButton,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  Modal,
  PrimaryButton,
  Text,
} from "@certn/cascadia-react";
import { Trans, useTranslation } from "react-i18next";

type ReactivateUserModalProps = {
  isOpen: boolean;
  isLoading: boolean;
  name: string | null;
  onCancel: () => void;
  onConfirm: () => void;
};

export function ReactivateUserModal(props: ReactivateUserModalProps) {
  const { isOpen, isLoading, name, onConfirm, onCancel } = props;
  const { t } = useTranslation();

  return (
    <Modal isOpen={isOpen}>
      <Dialog>
        <DialogHeader onClose={props.onCancel}>
          {t("Reactivate {{ name }}?", { name })}
        </DialogHeader>
        <DialogContent>
          <Text style="global/body-primary">
            <Trans>
              By clicking ‘Reactivate user’, {{ name }}’s account access will be
              restored.
            </Trans>
          </Text>
        </DialogContent>
        <DialogFooter>
          <BasicButton size="medium" onPress={onCancel} testID="cancel-button">
            <Trans>Cancel</Trans>
          </BasicButton>
          <PrimaryButton
            type="submit"
            size="medium"
            isLoading={isLoading}
            onPress={() => onConfirm()}
            testID="reactivate-confirm-button"
          >
            <Trans>Reactivate user</Trans>
          </PrimaryButton>
        </DialogFooter>
      </Dialog>
    </Modal>
  );
}
